import { FailedImageHistoryTableInfoModel, FailedImageLogsResponseModel } from "../../app/data/documents/failedImageLogsModels";
export default interface FailedImageLogsState {
  requestStarted: boolean;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestError: string;
  requestCreator: string;
  records: FailedImageLogsResponseModel[];
  recordsRequest: PaginationModel | null;
  downloadCsv: boolean;
  tableInfo: FailedImageHistoryTableInfoModel;
};

export const initialFailedImageLogsState: FailedImageLogsState = {
  requestStarted: false,
  requestSucceed: false,
  requestFailed: false,
  requestError: "",
  requestCreator: "",
  records: [],
  recordsRequest: null,
  downloadCsv: false,
  tableInfo: {title: "", description: "", sections: []}
};
export interface PaginationModel {
    page: number,
    last: number,
  };
  